import {
  SOCKET_CONNECT,
  SOCKET_RECONNECT,
  SOCKET_DISCONNECT,
  SOCKET_REGISTER,
  SOCKET_MSG,
  SOCKET_SEND,
  MESSAGE_RECENT_CONTACT,
  MESSAGE_FETCH,
} from '../mutation-types';

const state = {
  $socket: null,
  connect: false,
  contact: [],
  message: {},
};

import Vue from 'vue';
import userInfo from './user';
import api from '../../api';

const mutations = {
  [SOCKET_CONNECT] (state) {
    state.connect = true;
  },
  [SOCKET_RECONNECT] (state) {
    state.connect = true;
  },
  [SOCKET_DISCONNECT] (state) {
    state.connect = false;
  },
  [SOCKET_REGISTER] (state, userid, session) {
    state.$socket.emit('register', {
      userid: userid,
      session: session,
    }, () => {
      // eslint-disable-next-line
    })
  },
  [SOCKET_MSG] (state, info) {
    if (!state.message[info.from]) {
      if (state.contact.indexOf(info.from) < 0) state.contact.push(info.from);
      Vue.set(state.message, info.from, []);
    }
    state.message[info.from].push(info);
  },
  [SOCKET_SEND] (state, to, content) {
    if (!state.message[to]) {
      if (state.contact.indexOf(to) < 0) state.contact.push(to);
      Vue.set(state.message, to, []);
    }
    var id = state.message[to].length;
    state.message[to].push({
      from: userInfo.state.userid,
      to, content, sent: false,
    });
    Vue.http.post(api.message.send, {
      userid: userInfo.state.userid,
      session: userInfo.state.session,
      to_userid: to,
      content,
    }).then(() => {
      state.message[to][id].sent = true;
    });
  },
  [MESSAGE_RECENT_CONTACT] (state) {
    Vue.http.post(api.message.list, {
      userid: userInfo.state.userid,
      session: userInfo.state.session,
    }).then((res) => {
      state.contact = res.body.contact;
    });
  },
  [MESSAGE_FETCH] (state, userid) {
    Vue.http.post(api.message.get, {
      userid: userInfo.state.userid,
      session: userInfo.state.session,
      to_userid: userid,
      offset: (state.message[userid] || []).length,
    }).then((res) => {
      if (!state.message[userid]) {
        Vue.set(state.message, userid, []);
      }
      for (var i in res.body.message) {
        res.body.message[i].from = res.body.message[i].from_userid;
        res.body.message[i].to = res.body.message[i].to_userid;
        state.message[userid].unshift(res.body.message[i]);
      }
    });
  },
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/vuex/modules/message.js